/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
/**
 * Stores the information needed to invoke a function.
 */
var InvocationHandler = /** @class */ (function () {
    /**
     * Instantiates an InvocationDescription.
     * @param fn The Function described by this description object.
     * @param invoker The strategy for invoking the function.
     * @param dependencies The static dependencies of the function call.
     */
    function InvocationHandler(fn, invoker, dependencies) {
        this.fn = fn;
        this.invoker = invoker;
        this.dependencies = dependencies;
    }
    /**
     * Invokes the function.
     * @param container The calling container.
     * @param dynamicDependencies Additional dependencies to use during invocation.
     * @return The result of the function invocation.
     */
    InvocationHandler.prototype.invoke = function (container, dynamicDependencies) {
        if (dynamicDependencies !== undefined) {
            return this.invoker.invokeWithDynamicDependencies(container, this.fn, this.dependencies, dynamicDependencies);
        }
        return this.invoker.invoke(container, this.fn, this.dependencies);
    };
    return InvocationHandler;
}());
export { InvocationHandler };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW52b2NhdGlvbkhhbmRsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJJbnZvY2F0aW9uSGFuZGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQTs7Ozs7R0FLRztBQUVIOztHQUVHO0FBQ0g7SUFnQkk7Ozs7O09BS0c7SUFDSCwyQkFBbUIsRUFBWSxFQUFFLE9BQWdCLEVBQUUsWUFBbUI7UUFDbEUsSUFBSSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUM7UUFDYixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUN2QixJQUFJLENBQUMsWUFBWSxHQUFHLFlBQVksQ0FBQztJQUNyQyxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxrQ0FBTSxHQUFiLFVBQWMsU0FBb0IsRUFBRSxtQkFBMkI7UUFDM0QsSUFBSSxtQkFBbUIsS0FBSyxTQUFTLEVBQUU7WUFDbkMsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLDZCQUE2QixDQUM3QyxTQUFTLEVBQ1QsSUFBSSxDQUFDLEVBQVMsRUFDZCxJQUFJLENBQUMsWUFBWSxFQUNqQixtQkFBbUIsQ0FDdEIsQ0FBQztTQUNMO1FBQ0QsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxTQUFTLEVBQUUsSUFBSSxDQUFDLEVBQVMsRUFBRSxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUM7SUFDN0UsQ0FBQztJQUNMLHdCQUFDO0FBQUQsQ0FBQyxBQTdDRCxJQTZDQyJ9